import React, {FC} from "react";
import Gimage from "../components/Gimage";
import {Grid} from "@material-ui/core";

export interface Work{
    title:string,
    subtitle:string,
    description:React.ReactElement;
}

export const Works:Array<Work> = [
    {
        title:"並列計算される遺伝子",
        subtitle:"PARCO P.O.N.D.",
        description:(
            <div>
                <div>
                    GPUによって生態系や遺伝子による形質遺伝の営みをシミュレーションし、それをビジュアライズしたリアルタイムかつインタラクティブなインスタレーション作品。

                    2022年のPARCO P.O.N.D.に展示。<br/>
                    <a href="https://pond.parco.jp/">PARCO P.O.N.D.</a>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/inia4Hs0c_Y"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen></iframe>
                </div>
            </div>
        )
    },
    {
        title:"AI法廷の模擬裁判",
        subtitle:"PV映像・合成音声・リアルタイムビジュアライザ・演出等の制作",
        description:(
            <div>
                <div>

                    東京大学五月祭企画、「AI法廷の模擬裁判」にてPV映像、AI裁判官の音声、リアルタイム映像、演出システムの制作などを行いました。
                    詳細な技術記事は以下を参照してください。
                    <a href="https://proxima.hateblo.jp/entry/2023/05/26/195625">https://proxima.hateblo.jp/entry/2023/05/26/195625</a>
                    <div className={"EmbeddingContainer"}>
                        <blockquote className="twitter-tweet"><p lang="ja" dir="ltr">📢 予告篇・解禁<br/><br/>待望のYoutubeライブが決定。<br/>さらに、スポンサーに弁護士ドットコムを迎えました。<br/><br/>〜〜〜〜〜<br/><br/>GPT４を”裁判官”にした国内初の模擬裁判公開実演。<br/><br/>機械に人は裁けるかーー？<br/><br/>2023年５月13日（土）13：15、ついに開廷。 <a href="https://t.co/IgLx9cnZgk">pic.twitter.com/IgLx9cnZgk</a></p>&mdash; AI法廷の模擬裁判/東大五月祭 (@AI_Judge_May) <a href="https://twitter.com/AI_Judge_May/status/1651904687262822402?ref_src=twsrc%5Etfw">April 28, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                    </div>
                </div>
            </div>
        )
    },
    {
        title:"Blender - Geometry Nodes",
        subtitle:"Geometry Nodes によるプロシージャル技術の研究",
        description:(
            <div>
                BlenderのGeometry Nodes機能やHoudiniを利用してコンテンツ制作の様々な処理を自動化する試みを行っています。
                <iframe width="560" height="315" src="https://www.youtube.com/embed/xx9NVlimo5M?si=Hcq4To1eY-8VaebO" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/LEor9JkS0YA?si=OO97v76nkDHlICTc" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">リハビリがてらBlenderで文字打つと自動でかわいい感じの3Dのモーショングラフィックスとエフェクト付けてくれるシステム作りました<br/>文字のパーツごとに分けて動き付けられる <a href="https://t.co/8eKgmb60UM">pic.twitter.com/8eKgmb60UM</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1701203947854446875?ref_src=twsrc%5Etfw">September 11, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">Blenderでピタゴラ装置めいたアニメーションを無限に自動生成出来るシステムを作りました 　凄いデカいやつとか作れる <a href="https://t.co/PHVz1wHioB">pic.twitter.com/PHVz1wHioB</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1598633077420347393?ref_src=twsrc%5Etfw">December 2, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">blenderで文字を入力するだけでモーショングラフィックスを自動生成してくれる仕組みを作っています　一文字をいい感じに分離して動きをつけてくれるのでだいぶそれっぽいかも ？ <a href="https://t.co/5iGA4fzr4y">pic.twitter.com/5iGA4fzr4y</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1550805425691340801?ref_src=twsrc%5Etfw">July 23, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">線を引くだけで歯車機構を作れるペンをBlenderで作りました<br/><br/>歯車の回転がちゃんと噛み合うようになっているのでお手軽にそれっぽいスチームパンク装飾をやることが出来ます <a href="https://t.co/QTjJq2DiwF">pic.twitter.com/QTjJq2DiwF</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1530156877191032833?ref_src=twsrc%5Etfw">May 27, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">Blenderで好きな形のカーブからランダムなビルを自動生成してくれる仕組みを作りました<br/>遠景ぐらいならこれ単体でも十分使えそう…！ <a href="https://t.co/wH2u3vqitL">pic.twitter.com/wH2u3vqitL</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1520010011820265472?ref_src=twsrc%5Etfw">April 29, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
                <div className={"EmbeddingContainer"}>
                    <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">Blenderでテキストを打つだけでネオンサインを生成できる仕組みを作りました　配線とか支柱とかも自動生成してくれるので便利 <a href="https://t.co/Gl9qDqKOuQ">pic.twitter.com/Gl9qDqKOuQ</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1513109538957717507?ref_src=twsrc%5Etfw">April 10, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                </div>
            </div>
        )
    },
    {
        title:"たがいにかかわりあういのち",
        subtitle:"東大制作展2023にて展示された作品",
        description:(
            <div>
                <div>
                    GPUによって生態系や遺伝子による形質遺伝の営みをシミュレーションし、それをビジュアライズしたリアルタイムかつインタラクティブなインスタレーション作品。
                    2023年度東大制作展にて展示を行いました。

                    <a href="https://www.iiiexhibition.com/">東大制作展</a>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/PagEiE57Vvk?si=iH8KG-AOZN6LYdQi" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>
            </div>
        )
    },
    {
        title:"VJ",
        subtitle:"ジェネラティブ系",
        description:(
            <div>
                <div>
                    自作のVJ用ソフトを用いてジェネラティブ系のVJ活動を行っています。
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/UalcppWPqks?si=Z0CnaFP02XGRuICc" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    <div className={"EmbeddingContainer"}>
                        <blockquote className="twitter-tweet" data-media-max-width="560"><p lang="ja" dir="ltr">VJやってます <a
                            href="https://t.co/TWWDnfox1P">pic.twitter.com/TWWDnfox1P</a></p>&mdash; 避雷 (@lucknknock) <a href="https://twitter.com/lucknknock/status/1733427717679554960?ref_src=twsrc%5Etfw">December 9, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                    </div>
                    <ul>
                        <li>Channel 22</li>
                        <li>東大稲見研究室設立20周年記念懇親会</li>
                    </ul>
                </div>
            </div>
        )
    },
    {
        title:"Shaders",
        subtitle:"グラフィック&コーディング",
        description:(
            <div>
                <div>
                    ShaderToy,NEORT,Unityなどでシェーダーを書いています。 <br/>
                    <a href="">ShaderToy</a><br/>
                    <a href="">NEORT</a>
                </div>
                <Grid container>
                    <Grid item xs={3}>
                    </Grid>
                    <Grid item xs={6}>
                        <Gimage src={"E.PNG"}/>
                    </Grid>
                    <Grid item xs={3}>
                    </Grid>
                </Grid>

            </div>
        )
    },
    {
        title:"技術記事など",
        subtitle:"Qiita,Zenn…",
        description:(
            <div>
                <div>
                    Unityなどを中心に技術記事を書いています。
                </div>
                <div>
                    <a href="https://qiita.com/Hirai0827">qiita</a>
                </div>
            </div>
        )
    },
    {
        title:"LiCo",
        subtitle:"シェーダーライブコーディング2.0",
        description:(
            <div>
                <div>
                    ライブコーディングをいつでも再生できるようにアーカイブする試み <br/>
                    IPA未踏の支援を受けて制作しました。
                </div>
                <a href="https://lico-shader.net/">LiCo</a>
                <div style={{width:"50%",left:"25%"}}>
                    <Gimage src={"lico.png"}/>
                </div>
            </div>
        )
    },
    {
        title:"Dynamis",
        subtitle:"XMLでシェーダー芸ができるツール",
        description:(
            <div>
                <div>
                    XMLでレイマーチングによる3D表現を可能にするライブラリです。 <br/>
                    パーサからコードの生成まで自作しました。
                </div>
                <a href="https://github.com/Hirai0827/Dynamis">Dynamis</a><br/>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/bMde40BKPbs"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
            </div>
        )
    },
    {
    title:"ShaderPeeper",
        subtitle:"シェーダー用グラフィカルデバッグツール",
        description:(
            <div>
                <div>
                    シェーダーの中間変数をレンダリングすることができるシステムを作成しました。<br/>
                    カーソルの位置に応じてGLSLコードを途中で切断して該当変数をレンダリングするシェーダーを生成します。
                </div>
                <a href="https://github.com/Hirai0827/ShaderPeeper">ShaderPeeper</a>
                <div style={{width:"50%",left:"25%"}}>
                    <Gimage src={"lico.png"}/>
                </div>
            </div>
        )
    },
    {
        title:"擬字録",
        subtitle:"GAN+説文解字",
        description:(
            <div>
                <div>
                    GANによって存在しない篆書体の文字を生成する試み
                </div>
                <a href="https://twitter.com/lucknknock/status/1288458533487308801">twitter</a>
                <div style={{width:"50%",left:"25%"}}>
                    <Grid item xs={3}>
                    </Grid>
                    <Grid item xs={6}>
                        <Gimage src={"giji.png"}/>
                    </Grid>
                    <Grid item xs={3}>
                    </Grid>
                </div>
            </div>
        )
    },
    {
        title:"群衆シミュレータ",
        subtitle:"GPUとシェーダーの暴力",
        description:(
            <div>
                <div>
                    群衆シミュレータ、任意の地形に対してGPU上で接触判定を行う試み
                </div>
                <a href="https://twitter.com/lucknknock/status/1314548668251271169">twitter</a>
                <div style={{width:"50%",left:"25%"}}>
                    <Gimage src={"walking.png"}/>
                </div>
            </div>
        )
    },
    {
        title:"ShaderRec",
        subtitle:"シェーダー記録ツール",
        description:(
            <div>
                <div>
                    シェーダーを高画質高FPSの動画に変換することができるツールです。
                </div>
                <a href="https://shader-rec.herokuapp.com/">ShaderRec</a>
                <div style={{width:"50%",left:"25%"}}>
                    <Gimage src={"shaderrec.png"}/>
                </div>
            </div>
        )
    },
    {
        title:"Moment",
        subtitle:"NEORT++",
        description:(
            <div>
                <div>
                    NEORT社の物理ギャラリーであるNEORT++の展示第一弾として、仮想空間と物理空間両方に展示を行いました
                    花はNFTで管理されており、mintによって展示空間に設置された桜の木に花を咲かせることが出来る。
                    仮想空間全体のデザインを担当しました。
                    <a href="https://moment.neort.io/ja">NEORT MOMENT</a>
                    <Gimage src={"exhibition_moment.png"}/>
                    <Gimage src={"tree_moment.png"}/>
                </div>
            </div>
        )
    },
    {
        title:"その他",
        subtitle:"Others",
        description:(
            <div>
                <div>
                    その他の進捗はTwitterのモーメントにてまとめています。
                </div>
                <a href="https://twitter.com/i/events/1354924942249189376">Twitter(Moment)</a>
            </div>

        )
    },
]